import {Component, OnInit, Input} from "@angular/core";
import { RoutingDisablerService } from '../../../@inax/common/src/routing/RoutingDisablerService/RoutingDisabler.service';


@Component({
    selector: 'testpage',
    templateUrl: 'app/components/testpage/testpage.component.html',
    styleUrls: ['app/components/testpage/testpage.component.css']
})
export class TestPageComponent implements OnInit {
    constructor(private _routingDisablerService: RoutingDisablerService) {
    }

    public ngOnInit() {
    }

    toggleDisableRouting() {
        if (this._routingDisablerService.isDisabled) {
            this._routingDisablerService.enable("testlock");
        }
        else {
            this._routingDisablerService.disable("testlock");
        }
    }
}
